<vb-webcast-view *ngIf="!webcast.currentUser.isRemovedFromWebcast; else attendeeRemoved" layout="column" layout-wrap="false" [accountId]="accountId" [analyticsViewContext]="analyticsViewContext" [webcast]="webcast" [sidebarNotifications]="sidebarNotifications" [webcastViewContext]="webcastViewContext" (onPlayerReady)="onPlayerReady($event.player, $event.vgAPI)">
</vb-webcast-view>

<ng-template #attendeeRemoved>
	<div class="container-fluid">
		<div class="row">
			<div class="col-xs-12">
				<div>
					<div class="centered-copy">
						<div class="alert alert-danger">
							<span class="glyphicons circle_exclamation_mark"></span>
							{{ 'Event_AttendeeRemovedFromWebcast' | translate }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
